import { setAssetGroups } from '@casops/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@casops/filters/types';
import MultiselectFilter from '../multiselect/MultiselectFilter';
import { AssetGroupModel, useListAssetGroupsQuery } from '@casops/store/apis/assetGroupsApi';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';

export const useAssetGroupOptions = (): DropdownItemProps<string>[] => {
  const { data: assetGroups } = useListAssetGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  return useMemo(() => {
    return assetGroups
      ? assetGroups.map(({ id, name }: AssetGroupModel) => {
          const value = id.toString();
          return { key: value, value, stringValue: value, label: name };
        })
      : [];
  }, [assetGroups]);
};

export const AssetGroupsFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();
  return (
    <MultiselectFilter<string>
      filterName="assetGroups"
      label={label ?? t('Fields.Filters.AssetGroup')}
      action={setAssetGroups}
      elementRef={elementRef}
      useItemsHook={useAssetGroupOptions}
    />
  );
};

export default AssetGroupsFilter;
